/**
 * Thouch ID const symbols.
 * @constant
 * @type {Object}
 */
const TOUCH_ID = {
    KEY_TOKEN: 'touch_token',
    KEY_TOUCH_ENABLE: 'touchenable',
    KEY_TOUCH_ACTIVATION_CLICKED: 'activationclicked',
    KEY_OPEN_NATIVE_TOUCH_TXT: 'touch_id_native_open_subtitle',
    KEY_TRY_AGAIN_CAPTION: 'touch_id_try_again_caption',
    KEY_TRY_AGAIN_TXT: 'touch_id_try_again_txt',
    KEY_BUT_SKIP: 'touch_id_but_skip',
    KEY_BUT_TRY_AGAIN: 'touch_id_but_try_again',
    KEY_BUT_DISABLE_OK: 'touch_id_disable_but_ok',
    KEY_DISABLE_TXT: 'touch_id_disable_but_txt',
    KEY_SUCCESS: 'success',
    KEY_REASON: 'reason',
    KEY_DEVICE_ID: 'DeviceId',
    KEY_BUNDLE_ID: 'BundleId',
    KEY_TARGET_TYPE: 'TargetType',
    KEY_TARGET_TYPE_VALUE: 'TargetTypeValue',
    KEY_EROR_FAILD: -1,
    KEY_EROR_CANCEL: -2,
    KEY_EROR_LOCK_OUT: -8,
    //PASS_CHANGED: 300,
    //TOKEN_EXPIRE: 305
/*
#define kLAErrorAuthenticationFailed                       -1
#define kLAErrorUserCancel                                 -2
#define kLAErrorUserFallback                               -3
#define kLAErrorSystemCancel                               -4
#define kLAErrorPasscodeNotSet                             -5
#define kLAErrorTouchIDNotAvailable                        -6
#define kLAErrorTouchIDNotEnrolled                         -7
#define kLAErrorTouchIDLockout                             -8
#define kLAErrorAppCancel                                  -9
#define kLAErrorInvalidContext                            -10
*/
};


export {TOUCH_ID};